export const quoteDataInitialState = {
    quotes:[],
    quoteTab: [],
    isRated:false,
    showCallMessage: false
};
